import React from 'react';

import Layout from '../../../Layout';
import Tag from '../../../Tag';
import Text from '../../../Text';
import BaseCell from '../BaseCell';

/** Padding and height matching StatusPill size="md" (8px horizontal, 28px height). */
const SINGLE_TAG_PADDING_X = 10;
const SINGLE_TAG_HEIGHT = 28;

export interface TagCellProps {
  /** Single tag label. Renders as a pill matching dropdown cell container: gray-50 outline, body-xs gray-600 semibold. */
  value?: string | null;
  /** Multiple tags (tag group). Renders xs tags, left aligned. When set, value is ignored. */
  values?: string[];
}

const TagCell: React.FC<TagCellProps> = ({ value, values }) => {
  const tagGroup = values != null && values.length > 0;
  const singleValue = value != null && value !== '';

  if (tagGroup) {
    return (
      <BaseCell>
        <Layout direction="row" gap={4} align="flex-start" justify="flex-start" __style={{ flexWrap: 'wrap' }}>
          {values.map((v, index) => (
            <Tag key={index} value={v} onRemove={() => {}} removable={false} textSize="body-xs" />
          ))}
        </Layout>
      </BaseCell>
    );
  }

  if (singleValue) {
    return (
      <BaseCell>
        <Layout
          height={SINGLE_TAG_HEIGHT}
          paddingLeft={SINGLE_TAG_PADDING_X}
          paddingRight={SINGLE_TAG_PADDING_X}
          borderRadius={1000}
          color="gray-25"
          align="center"
        >
          <Text size="body-xs" color="gray-600" semibold ellipsis>
            {value}
          </Text>
        </Layout>
      </BaseCell>
    );
  }

  return <BaseCell value={null} />;
};

export default TagCell;
